module.exports = __webpack_public_path__ + "img/footer-logo-3.3c5ac09c.png";